<div
  class="side-menu-container cc-side-navigator-menu"
  [ngClass]="{ 'side-menu-container-sm': isSmallScreen }"
>
  <dx-box height="100%" direction="col">
    <dxi-item [ratio]="1">
      <!-- top menu -->
      <dx-box height="100%" direction="col">
        <dxi-item baseSize="auto">
          <div
            *dxTemplate
            class="top-item-menu"
            (click)="onParentMenuItemClick(homeMenu)"
          >
            <div class="top-item-header">
              <dx-button
                [ngClass]="{
                  'selected-header-icon-button': homeMenu?.selected,
                  'header-icon-button': !homeMenu?.selected
                }"
                [icon]="homeMenu?.icon"
                [hint]="homeMenu?.text"
              ></dx-button>
              <div
                *ngIf="!compactMode"
                [ngClass]="{
                  'selected-header-text': homeMenu?.selected,
                  'header-text': !homeMenu?.selected
                }"
              >
                {{ homeMenu?.text }}
              </div>
            </div>
          </div>
        </dxi-item>
        <dxi-item baseSize="auto">
          <div
            *dxTemplate
            class="top-item-menu"
            (click)="onParentMenuItemClick(paymentMenu)"
          >
            <div class="top-item-header">
              <dx-button
                [ngClass]="{
                  'selected-header-icon-button': paymentMenu?.selected,
                  'header-icon-button': !paymentMenu?.selected
                }"
                [icon]="paymentMenu?.icon"
                [hint]="paymentMenu?.text"
              ></dx-button>
              <div
                *ngIf="!compactMode"
                [ngClass]="{
                  'selected-header-text': paymentMenu?.selected,
                  'header-text': !paymentMenu?.selected
                }"
              >
                {{ paymentMenu?.text }}
              </div>
              <dx-button
                *ngIf="
                  !compactMode && paymentMenu?.items && !paymentMenu?.selected
                "
                class="header-icon-button-right"
                icon="chevronright"
              ></dx-button>
              <dx-button
                *ngIf="
                  !compactMode && paymentMenu?.items && paymentMenu?.selected
                "
                class="header-icon-button-right"
                icon="chevrondown"
              ></dx-button>
            </div>
          </div>
        </dxi-item>
        <dxi-item *ngIf="paymentMenu?.selected" [ratio]="1">
          <!-- payment sub menu -->
          <div *dxTemplate>
            <dx-scroll-view class="scroll-view-container">
              <div
                class="top-item-content"
                [ngClass]="{ 'top-item-content-hover': !compactMode }"
              >
                <div
                  class="content-text"
                  *ngFor="
                    let subitem of paymentMenu?.items;
                    trackBy: trackByPath
                  "
                  (click)="onChildMenuItemClick(paymentMenu, subitem)"
                >
                  <div
                    [ngClass]="{
                      'selected-each-text': subitem.selected,
                      'each-text': !subitem.selected
                    }"
                  >
                    <div *ngIf="!compactMode">{{ subitem.text }}</div>
                    <div
                      *ngIf="compactMode && subitem.selected"
                      class="top-selected-button"
                    >
                      {{ subitem.text }}
                    </div>
                  </div>
                </div>
              </div>
            </dx-scroll-view>
          </div>
          <!-- payment sub menu -->
        </dxi-item>
        <dxi-item baseSize="auto">
          <div
            *dxTemplate
            class="top-item-menu"
            (click)="onParentMenuItemClick(propertyMenu)"
          >
            <div class="top-item-header">
              <dx-button
                [ngClass]="{
                  'selected-header-icon-button': propertyMenu?.selected,
                  'header-icon-button': !propertyMenu?.selected
                }"
                [icon]="propertyMenu?.icon"
                [hint]="propertyMenu?.text"
              ></dx-button>
              <div
                *ngIf="!compactMode"
                [ngClass]="{
                  'selected-header-text': propertyMenu?.selected,
                  'header-text': !propertyMenu?.selected
                }"
              >
                {{ propertyMenu?.text }}
              </div>
              <dx-button
                *ngIf="
                  !compactMode && propertyMenu?.items && !propertyMenu?.selected
                "
                class="header-icon-button-right"
                icon="chevronright"
              ></dx-button>
              <dx-button
                *ngIf="
                  !compactMode && propertyMenu?.items && propertyMenu?.selected
                "
                class="header-icon-button-right"
                icon="chevrondown"
              ></dx-button>
            </div>
          </div>
        </dxi-item>
        <dxi-item *ngIf="propertyMenu?.selected" [ratio]="1">
          <!-- property sub menu -->
          <div *dxTemplate>
            <dx-scroll-view class="scroll-view-container">
              <div
                class="top-item-content"
                [ngClass]="{ 'top-item-content-hover': !compactMode }"
              >
                <div
                  class="content-text"
                  *ngFor="
                    let subitem of propertyMenu?.items;
                    trackBy: trackByPath
                  "
                  (click)="onChildMenuItemClick(propertyMenu, subitem)"
                >
                  <div
                    [ngClass]="{
                      'selected-each-text': subitem.selected,
                      'each-text': !subitem.selected
                    }"
                  >
                    <div *ngIf="!compactMode">{{ subitem.text }}</div>
                    <div
                      *ngIf="compactMode && subitem.selected"
                      class="top-selected-button"
                    >
                      {{ subitem.text }}
                    </div>
                  </div>
                </div>
              </div>
            </dx-scroll-view>
          </div>
          <!-- property sub menu -->
        </dxi-item>
        <dxi-item baseSize="auto">
          <div
            *dxTemplate
            class="top-item-menu"
            (click)="onParentMenuItemClick(communityMenu)"
          >
            <div class="top-item-header">
              <dx-button
                [ngClass]="{
                  'selected-header-icon-button': communityMenu?.selected,
                  'header-icon-button': !communityMenu?.selected
                }"
                [icon]="communityMenu?.icon"
                [hint]="communityMenu?.text"
              ></dx-button>
              <div
                *ngIf="!compactMode"
                [ngClass]="{
                  'selected-header-text': communityMenu?.selected,
                  'header-text': !communityMenu?.selected
                }"
              >
                {{ communityMenu?.text }}
              </div>
              <dx-button
                *ngIf="
                  !compactMode &&
                  communityMenu?.items &&
                  !communityMenu?.selected
                "
                class="header-icon-button-right"
                icon="chevronright"
              ></dx-button>
              <dx-button
                *ngIf="
                  !compactMode &&
                  communityMenu?.items &&
                  communityMenu?.selected
                "
                class="header-icon-button-right"
                icon="chevrondown"
              ></dx-button>
            </div>
          </div>
        </dxi-item>
        <dxi-item *ngIf="communityMenu?.selected" [ratio]="1">
          <!-- community sub menu -->
          <div *dxTemplate>
            <dx-scroll-view class="scroll-view-container">
              <div
                class="top-item-content"
                [ngClass]="{ 'top-item-content-hover': !compactMode }"
              >
                <div
                  class="content-text"
                  *ngFor="
                    let subitem of communityMenu?.items;
                    trackBy: trackByPath
                  "
                  (click)="onChildMenuItemClick(communityMenu, subitem)"
                >
                  <div
                    [ngClass]="{
                      'selected-each-text': subitem.selected,
                      'each-text': !subitem.selected
                    }"
                  >
                    <div *ngIf="!compactMode">
                      {{ subitem.text }}
                      <span *ngIf="subitem.badge" class="menu-item-badge">
                        {{ subitem.badge }}
                      </span>
                    </div>
                    <div
                      *ngIf="compactMode && subitem.selected"
                      class="top-selected-button"
                    >
                      {{ subitem.text }}
                    </div>
                  </div>
                </div>
              </div>
            </dx-scroll-view>
          </div>
          <!-- community sub menu -->
        </dxi-item>
      </dx-box>
    </dxi-item>

    <dxi-item baseSize="auto">
      <dx-box height="100%" direction="col">
        <!-- bottom menu-->
        <dxi-item baseSize="auto">
          <dx-tree-view
            #bottomMenuItems
            expandEvent="click"
            width="100%"
            [items]="bottomItems"
            (onInitialized)="onMenuInitialized($event)"
            (onItemClick)="onItemClick($event)"
            (onContentReady)="updateSelection($event)"
            (onSelectionChanged)="updateSelection($event)"
            [selectByClick]="true"
            selectionMode="single"
            keyExpr="path"
          ></dx-tree-view>
        </dxi-item>
        <!-- RealAssist Banner -->
        <dxi-item baseSize="auto">
          <div
            *dxTemplate
            class="realassist-banner"
            [ngClass]="{ 'realassist-banner-compact': compactMode }"
          >
            <div class="realassist-content">
              <div class="realassist-icon">
                <img src="/assets/images/RealAssistBot.svg" alt="RealAssist" />
              </div>
              <div class="realassist-text">
                <div class="realassist-header">
                  <span class="realassist-title">RealAssist</span>
                  <span class="realassist-badge">Coming Soon</span>
                </div>
                <div class="realassist-subtitle">YOUR HOA AI CONCIERGE</div>
              </div>
            </div>
          </div>
        </dxi-item>
      </dx-box>
    </dxi-item>
  </dx-box>
</div>
